<template>
  <div class="payment-info-wrapper">
    <template v-if="loading">
      <v-skeleton-loader
        v-for="(page, i) in 5"
        :key="'skeletonloader-' + i"
        type="list-item"
        ref="skeleton"
        style="height: 40px"
        class="mx-auto my-0 py-0"
      ></v-skeleton-loader>
    </template>
    <template v-if="!noResults && !loading">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Token</th>
              <th class="text-left">Date</th>
              <th class="text-left">Time</th>
            </tr>
          </thead>
          <tbody v-if="appointments">
            <tr v-for="appointment in appointments" :key="appointment.id">
              <td>{{ appointment.tokenNumber }}</td>
              <td>
                {{ appointment.agendaSlot ? formatDate(appointment.agendaSlot.date) : 'Appointment not booked' }}
                <v-chip v-if="appointment.agendaSlot && isToday(appointment.agendaSlot.date)" color="success" x-small class="font-weight-bold"
                  >Today</v-chip
                >
              </td>
              <td>{{ appointment.agendaSlot ? formatTime(appointment.agendaSlot.date) : '' }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <div class="subtitle-1" v-if="noResults">No Results</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SharedFunctions from '@/mixins/SharedFunctions.vue';

export default {
  mixins: [SharedFunctions],
  props: ['primarySubject'],
  data() {
    return {
      loading: false,
      appointments: [],
      noResults: false
    };
  },
  computed: {
    ...mapGetters({ storedVistorSubjects: 'testTubeLinkStore/caseAppointments' }),
    patientCaseId() {
      if (this.primarySubject?.patientCaseId) return this.primarySubject.patientCaseId;
      else return '';
    }
  },
  watch: {
    patientCaseId(n, o) {
      if (n && n != o) this.getAppointments();
    }
  },
  created() {
    this.getAppointments();
  },
  methods: {
    getAppointments() {
      this.loading = true;
      this.noResults = false;
      this.$store
        .dispatch('testTubeLinkStore/getCaseAppointments', this.primarySubject.patientCaseId)
        .then((data) => {
          this.displaySearchData(data);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    clearPaymentInfo() {
      this.appointments = [];
    },
    displaySearchData(data) {
      if (data.length == 0) this.noResults = true;
      this.appointments = data;
    }
  }
};
</script>

<style lang="scss">
.payment-info-wrapper {
  table {
    background: #f5f5f5;
  }
}
</style>
